import { State } from '../../helpers/State';
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import { Snackbar, SnackbarCloseReason } from '@mui/material';

export interface MessagesState {
	open: boolean,
	message: string,
	type: AlertColor
}

export class MessagesViewModel {
	private _state: State<MessagesState>;

	constructor(state: State<MessagesState>) {
		this._state = state;
	}

	public Open(message: string, type: AlertColor) {
		this._state.Update({
			message: message,
			open: true,
			type: type,
		});
	}

	public Success(message: string) {
		this.Open(message, 'success');
	}

	public Info(message: string) {
		this.Open(message, 'info');
	}

	public Warning(message: string) {
		this.Open(message, 'warning');
	}

	public Error(message: string) {
		this.Open(message, 'error');
	}

	public CloseHandler() {
		this._state.Update({
			open: false
		});
	}

	public IsOpen(): boolean {
		return this._state.content.open;
	}

	public Message(): string {
		return this._state.content.message;
	}

	public Type(): AlertColor {
		return this._state.content.type;
	}
}

export interface MessagesProps {
	state: MessagesViewModel,
	duration?: number,
}

const Messages: React.FunctionComponent<MessagesProps> = props => {
	function onClose(event: Event | React.SyntheticEvent<any, Event>, reason: SnackbarCloseReason): void {
		if (reason === 'clickaway') {
			return;
		}

		props.state.CloseHandler();
	}

	function onAlertClose(event: React.SyntheticEvent<any>) {
		props.state.CloseHandler();
	}

	function render(): JSX.Element {

		return <Snackbar open={props.state.IsOpen()} autoHideDuration={props.duration ?? 6000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
			<MuiAlert elevation={6} variant='filled' onClose={onAlertClose} severity={props.state.Type()}>{props.state.Message()}</MuiAlert>
		</Snackbar>
	}

	return render();
}


export default Messages;
